// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2mIqP","right":"Footer_right__34pTs","buttons":"Footer_buttons__2XIB8"};